
// import Barba from "barba.js";

// module.exports = class{

// 	constructor(){

//         const init = function(){
//             /iPhone|iPod|iPad|Android/i.test(navigator.userAgent) && document.documentElement.style.setProperty('--outer-height',`${window.outerHeight}px`)
//         }
// 		Barba.Dispatcher.on('transitionStart', init);
// 	}
// };


import barba from '@barba/core';
export default class{

	constructor(){
		this.Luxy;
		barba.hooks.beforeOnce((data) => {
            this.set()
        });
        barba.hooks.after((data) => {
            this.set()
        });
    }
    set (){
        const setFillHeight = () => {
            const vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        }

        let vw = window.innerWidth;

        window.addEventListener('resize', () => {
            if(vw === window.innerWidth) {
                return;
            }
            vw = window.innerWidth;
            setFillHeight();
        })

        setFillHeight();
    }
}